import React, { Component } from 'react';
import { Tree } from 'antd';
import UserProvider from '../../js/userProvider';
import DataService from '../../Components/Data';
const TreeNode = Tree.TreeNode;

var  treeData = [];

class FiltrosCorrida extends Component {

    constructor(props) {
        super(props);

        this.state = {
            expandedKeys: [],
            autoExpandParent: true,
            checkedKeys: props.checkedKeys,
            selectedKeys: [],
            loadingData: true,
        }

        this.dataService = new DataService();
        this.dadosProvider = UserProvider.getInstance();
    }

    findArrayElementByTitle(array, title) {
        return array.find((element) => {
            return element.title === title;
        })
    }

    componentWillMount() {

        var filial = this.dadosProvider.getUiFilial();
        var usuario = this.dadosProvider.getDadosUsuario();

        var dados = {
            "uiPessoa": usuario["UiPessoa"],
            "uiFilial": filial
        };

        treeData = [];

        this.dataService.GetFiltroAcessoPessoa(dados, (retorno) => {

            if (retorno.length > 0) {
                for (var i in retorno) {
                    var dado = retorno[i];

                    var elemento = this.findArrayElementByTitle(treeData, dado['DsPrefixoVeiculo']);

                    if(elemento){

                        elemento.children.push({
                            title: dado['DsMotorista'],
                            key: "M"+dado['UiPessoaMotorista']
                        }); 

                    }else{

                        treeData.push({
                            title: dado['DsPrefixoVeiculo'],
                            key: "V"+dado['UiPessoaVeiculo'],
                            children: [{
                                title: dado['DsMotorista'],
                                key: "M"+dado['UiPessoaMotorista']
                            }]
                        });
                    }
                   
                }
            }

            this.setState({
                buscando: false
            });

        }, (erro) => {
            console.log(erro)
            this.setState({ buscando: false });
        });
    }

    onExpand = (expandedKeys) => {
        console.log('onExpand', arguments);
        // if not set autoExpandParent to false, if children expanded, parent can not collapse.
        // or, you can remove all expanded children keys.
        this.setState({
            expandedKeys,
            autoExpandParent: false,
        });
    }

    onCheck = (checkedKeys) => {
        this.props.onCheckKey(checkedKeys);
        this.setState({ checkedKeys });
    }

    onSelect = (selectedKeys, info) => {
        console.log('onSelect', info);
        this.setState({ selectedKeys });
    }

    renderTreeNodes = (data) => {
        return data.map((item) => {
            if (item.children) {
                return (
                    <TreeNode title={item.title} key={item.key} dataRef={item}>
                        {this.renderTreeNodes(item.children)}
                    </TreeNode>
                );
            }
            return <TreeNode {...item} />;
        });
    }

    render() {
        return (
            <div>
                <p>Selecione o prefixo do carro ou motorista que deseja ver</p>
                <Tree
                    checkable
                    onExpand={this.onExpand}
                    expandedKeys={this.state.expandedKeys}
                    autoExpandParent={this.state.autoExpandParent}
                    onCheck={this.onCheck}
                    checkedKeys={this.state.checkedKeys}
                    onSelect={this.onSelect}
                    selectedKeys={this.state.selectedKeys}
                >
                    {this.renderTreeNodes(treeData)}
                </Tree>
            </div>
        )
    }
}

export default FiltrosCorrida;


// WEBPACK FOOTER //
// ./src/Components/FiltrosCorrida/FiltrosCorrida.js